import React, { useEffect } from 'react';
import ResponseEntity from '../../../store/polls-store/response-entity';
import { sortByOrder } from '../../../utils/helpers/polls-helper';
import PollResponseVotes from '../poll-details/poll-details-components/poll-details-response';

interface IProps {
    responses: ResponseEntity[];
    countVotes: number;
    selectedPollId: string;
    getPollChoisesList: (selectedPollId: string) => Promise<ResponseEntity[] | void>;
    shouldHideVotesCount?: boolean;
}

const PollVotesList: React.FC<IProps> = ({ responses, countVotes, getPollChoisesList, selectedPollId, shouldHideVotesCount }) => {
  const filteredResponses = sortByOrder(responses);

  useEffect(() => {
    if (!filteredResponses.length) getPollChoisesList(selectedPollId);
  }, [filteredResponses.length]);

  return (
    <div className='poll-details-votes-container'>
      {filteredResponses.map(el => {
        return <PollResponseVotes key={el.pollChoiceId} response={el} totalCounts={countVotes} shouldHideVotesCount={shouldHideVotesCount}/>;
      })}
    </div>
  );
};

export default PollVotesList;